import * as Yup from 'yup'

export const userSchema = Yup.object({
  firstName: Yup.string().required('First Name is required!'),
  lastName: Yup.string(),

  email: Yup.string().email('Invalid Email!').required('Email is required!'),
  active: Yup.boolean(),
})
